import { Box, Flex } from '@chakra-ui/react';
import { Tag, Text } from '@kula-ai/components';
import type { IcpBlockData } from '../../../types';

interface IcpBlockProps {
  data: IcpBlockData;
}

// Ideal-candidate profile card (kula_job_match_candidates). Rendered before
// the candidate results so the recruiter sees exactly which criteria drive
// the match — and can fix them (rerun AI scoring, sharpen the JD) when they
// look off, instead of puzzling over odd results.
export const IcpBlock = ({ data }: IcpBlockProps) => {
  if (!data.summary && data.criteria.length === 0) return null;

  const subtitle = [data.jobTitle, data.source && `from ${data.source}`]
    .filter(Boolean)
    .join(' · ');

  return (
    <Box
      border="1px solid"
      borderColor="secondary-200"
      borderRadius="10px"
      bg="base-white"
      px="14px"
      py="12px"
      maxW="640px"
      data-test-id="icp-block"
    >
      <Flex direction="column" gap="8px">
        <Flex direction="column" gap="2px">
          <Text variant="span" className="text-secondary-900 font-semibold">
            Ideal-candidate profile
          </Text>
          {subtitle && (
            <Text variant="small" className="text-secondary-500">
              {subtitle}
            </Text>
          )}
        </Flex>
        {data.criteria.length > 0 ? (
          <Flex wrap="wrap" gap="6px">
            {data.criteria.map((c) => (
              <Tag
                key={c}
                label={c}
                size="md"
                variant="outline"
                data-test-id="icp-criterion"
              />
            ))}
          </Flex>
        ) : (
          <Text variant="small" className="text-secondary-700">
            {data.summary}
          </Text>
        )}
      </Flex>
    </Box>
  );
};
